.mvAreaFormItem {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: stretch;
    width: 50%;
    padding: 0 0.5rem;
}

.mvLoadingIcon {
    margin-right: 0.5rem;
    width: 3rem;
    position: absolute;
    left: 50%;
    bottom: 50%;
    transform: translate(-50%, 50%);
}
